import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../i18n';

const BackToDashboardBtn = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <button
      onClick={() => navigate('/trainer-dashboard')}
      style={{
        background: '#193255',
        color: '#fff',
        border: 'none',
        borderRadius: 999,
        padding: '8px 20px',
        fontSize: 13,
        fontWeight: 700,
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
      }}
    >
      {t('trainerDashboard.backToDashboard')}
    </button>
  );
};

export default BackToDashboardBtn;
